const LOG_LEVELS = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info'
};

// Force direct console output for debugging
const logError = (message, error = null) => {
  const timestamp = new Date().toISOString();
  console.error(`[${timestamp}] [ERROR] ${message}`, error);
};

const logWarning = (message) => {
  const timestamp = new Date().toISOString();
  console.warn(`[${timestamp}] [WARN] ${message}`);
};

const logInfo = (message) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] [INFO] ${message}`);
};

export { logError, logWarning, logInfo }